module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainLayout"
  }, [_c('section', {
    staticClass: "addRutto"
  }, [_c('div', {
    staticClass: "inputBase"
  }, [_c('p', [_vm._v("Inserisci qui l'url youtube del video che vuoi condividere con la comunita")]), _vm._v(" "), _c('div', {
    staticClass: "inserisciUrl-cont"
  }, [_c('i', {
    staticClass: "gdr-icon gdr-icon-youtube-play"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUrl),
      expression: "newUrl"
    }],
    staticClass: "inserisciUrl",
    attrs: {
      "type": "url",
      "pattern": "^(https://www.youtube.com/)"
    },
    domProps: {
      "value": (_vm.newUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUrl = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.youtubeVideoID) ? _c('div', {
    staticClass: "addVideoAnteprimaVideo",
    staticStyle: {
      "max-width": "450px"
    }
  }, [_c('p', [_vm._v("vuoi aggiungere questo video?")]), _vm._v(" "), _c('videoplayer', {
    attrs: {
      "videoID": _vm.youtubeVideoID,
      "previewType": "video",
      "vote": false,
      "shadow": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "buttonAddTo-cont"
  }, [_c('button', {
    staticClass: "buttonAddTo",
    on: {
      "click": _vm.addToCommunity
    }
  }, [_vm._v("Aggiungi alla lista")])])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dbcfe264","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/addRutto.vue
// module id = 243
// module chunks = 5